import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import ProductModel from '@/shared/models/configuration/productmodel'
import ProductForms from './product-form'

import ProductRepository from '@/shared/http/repositories/configuration/product'
import BusinessTypeRepository from '@/shared/http/repositories/configuration/businesstype'
import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'

export default {
  name: 'Product',
  mixins: [ActionsForm],
  data () {
    return {
      data: ProductModel,
      form: ProductForms,
      pollingBusinessType: null
    }
  },
  components: {
    Cfg
  },
  created () {
    this.onClear()
  },
  mounted () {
    this.onLoadAllInsurance()
  },
  methods: {
    onLoad () {
      loading.push()
      ProductRepository.GetAll()
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      ProductRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      ProductRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      ProductRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBusinessType(obj.insuranceID)
      }, 500)
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onLoadAllBusinessType (insurance) {
      if (insurance !== null) {
        loading.push()
        BusinessTypeRepository.GetAllByInsuranceID(insurance)
          .then((response) => {
            this.form.businessTypeID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onLoadAllInsurance () {
      InsuranceRepository.GetAll()
        .then((response) => {
          this.form.insuranceID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeInsurance () {
      var value = this.form.insuranceID.value
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBusinessType(value)
      }, 500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/product/product.js